import React from "react";
import styled from "styled-components";
import Carousel from "../components/Carousel";

const EventsSection = styled.section`
  padding: 6rem 0;
  background-color: var(--surface, #f8f9fa);
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const SectionHeader = styled.div`
  margin-bottom: 4rem;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: var(--text, #212529);
  font-weight: 700;
  letter-spacing: -0.5px;

  span {
    color: var(--primary, #007bff);
    position: relative;
    display: inline-block;

    &:after {
      content: "";
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 8px;
      background: linear-gradient(
        90deg,
        var(--primary, #007bff),
        var(--accent, #6c757d)
      );
      z-index: -1;
      opacity: 0.2;
      border-radius: 4px;
      transition: all 0.3s ease;
    }

    &:hover:after {
      opacity: 0.4;
      height: 10px;
    }
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: var(--textSecondary, #6c757d);
  text-align: center;
  max-width: 700px;
  margin: 0 auto 1rem;
  line-height: 1.6;
`;
const images = Object.values(
  import.meta.glob("../images/eventPhoto/*.{png,jpg,jpeg,svg}", {
    eager: true,
  })
).map((mod) => mod.default);

const PastEvents = () => {
  return (
    <EventsSection>
      <Container>
        <SectionHeader>
          <SectionTitle>
            Ovako je bilo na prošlom <span> UNINPHACKATHONU</span>
          </SectionTitle>
          <SectionSubtitle>
            Naš prošli hackathon je bio pun sjajnih ideja, inovacija i timskog
            duha.
            <br /> Pogledajte kako je izgledalo i pridružite nam se na sledećem!
          </SectionSubtitle>
        </SectionHeader>

        {images.length > 0 && (
          <Carousel images={images} objfit={"cover"} flex={"250px"} />
        )}
      </Container>
    </EventsSection>
  );
};

export default PastEvents;
